import React from 'react';

const AboutUsSection = () => {
  return (
    <div className="section-full site-bg-white p-t150 p-b120 twm-abus-section-wrap wow fadeInDown pb-5" data-wow-offset="100" data-wow-delay="0.2">
      <div className="container">
        <div className="row twm-abus-section">

          {/* Left Column */}
          <div className="col-lg-7 col-md-12">
            <div className="twm-abus-left">
              <div className="twm-media">
                <img src="images/abus-pic.jpg" alt="About Us" />
                {/* <div className="twm-abus-video">
                  <a href="https://vimeo.com/337649532" className="mfp-video">
                    <i className="icon fa fa-play"></i>
                  </a>
                </div> */}
                <div className="twm-abus-year-section">
                  <div className="tem-abus-year-content">
                    <span>Since</span>
                    <h2 className="year-title">2020</h2>
                  </div>
                </div>
              </div>
              <div className="twm-media2">
                {/* <img src="images/car-pic1.png" alt="Car Image" /> */}
                <img src="/images/about/car.png" alt="Car Image" />
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-lg-5 col-md-12">
            {/* Title Section */}
            <div className="section-head left aside-section">
              <div className="twm-sm-title left">About Us</div>
              <h2 className="twm-large-title site-text-dark">
                We Have Many Provided Assistance To People And Companies In This Field
              </h2>
              <div className="section-head-detail">
              Since 2020, AB Ghule Cabs has been committed to providing seamless, reliable, and comfortable travel experiences for our customers. Our fleet of well-maintained vehicles, combined with expert drivers, ensures that each journey is safe, smooth, and enjoyable. Whether you're booking a quick ride within the city or an outstation adventure, AB Ghule Cabs tailors each trip to meet your needs. We take pride in offering punctual, affordable, and professional service, while always keeping customer satisfaction at the forefront. With a focus on trust, transparency, and comfort, AB Ghule Cabs makes every ride a pleasant experience. Let us be your travel companion, and we'll take you where you need to go with care, reliability, and dedication.
              <br/>
              AB Ghule Cabs has been a trusted name in the transportation industry since 2020, dedicated to providing our customers with seamless, reliable, and comfortable travel experiences. Over the years, we’ve grown into a preferred choice for individuals, families, and businesses who value punctuality, safety, and professional service.
              </div>
            </div>

            {/* List Section */}
            <div className="twm-inline-list2">
              <ul>
                <li>All Type Vehicle Available</li>
                <li>You Get 24/7 Roadside Assistance</li>
                <li>We Are The India's Largest Provider</li>
              </ul>
            </div>

            
          </div>

        </div>
      </div>
    </div>
  );
};

export default AboutUsSection;
